import React from 'react';

interface FormGenericContainerPropsBase {
  footer?: React.FC;
  bodyClassName?: string;
  footerClassName?: string;
}

type FormGenericContainerProps = React.HTMLAttributes<HTMLElement> & FormGenericContainerPropsBase;

export function FormGenericContainer(props: FormGenericContainerProps) {
  const {
    footer: FooterComponent,
    className: propClasses,
    bodyClassName: propBodyClasses,
    footerClassName: propFooterClasses,
    children,
    ...rest
  } = props;

  const classes = ['form-page-container'];
  if (propClasses) classes.push(propClasses);

  const bodyClasses = ['p-8'];
  if (FooterComponent) bodyClasses.push('pb-2');
  if (propBodyClasses) bodyClasses.push(propBodyClasses);

  const footerClasses = ['flex items-start sticky bottom-0 z-20 p-8 pt-4 form-blur'];
  if (propFooterClasses) footerClasses.push(propFooterClasses);

  return (
    <div {...rest} className={classes.join(' ')}>
      <div className={bodyClasses.join(' ')}>{children}</div>
      {FooterComponent && (
        <div className={footerClasses.join(' ')}>
          <FooterComponent />
        </div>
      )}
    </div>
  );
}
